import { render, staticRenderFns } from "./DepartmentGroupFilter.vue?vue&type=template&id=a0612a80&scoped=true&"
import script from "./DepartmentGroupFilter.vue?vue&type=script&lang=ts&"
export * from "./DepartmentGroupFilter.vue?vue&type=script&lang=ts&"
import style0 from "./DepartmentGroupFilter.vue?vue&type=style&index=0&id=a0612a80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0612a80",
  null
  
)

export default component.exports